<div class="flex-align-center flex">
    <span class="h-8 w-8">
        <ion-icon
            class="vl-app-light-dark:text-black bus-stop-text-color orb-app-light:text-secondary var-app-light:text-grey-zambezy hu-light:text-grey-zambezy h-8 w-8 rounded text-white dark:text-contrast-yellow"
            [src]="
                (assetsPath$ | async) +
                (env.EXPLORE?.USE_CONTRAST_ICON && (isContrast$ | async)
                    ? '/img/explore/bus-contrast.svg'
                    : '/img/explore/bus.svg')
            "
            [attr.aria-label]="'STOP' | translate"></ion-icon>
    </span>

    <div class="ml-3 text-left">
        <h2
            class="vl-app-light-dark:text-black orb-app-light-dark:text-xs orb-app-light:text-grey-dark word-break-break-word text-base font-semibold uppercase leading-5 dark:text-contrast-yellow"
            [class.normal-case]="env.REMOVE_UPPERCASE">
            {{ stop?.name }} {{ env.EXPLORE?.SHOW_MUNICIPALITY_IN_STOP_NAME ? '(' + stop?.desc + ')' : '' }}
        </h2>

        <div
            class="vl-app-light-dark:text-black text-xs leading-5 text-ironside_grey dark:text-contrast-yellow"
            *ngIf="stop?.code || stop?.desc || stop?.dist">
            {{ env.EXPLORE?.HIDE_SHORT_NAME ? '' : env.SEARCH_SETTINGS?.SHOW_DESCRIPTION ? stop?.desc : stop?.code }}
            <span
                *ngIf="
                    !env.EXPLORE?.HIDE_SHORT_NAME &&
                    (env.SEARCH_SETTINGS?.SHOW_DESCRIPTION ? stop?.desc : stop?.code) &&
                    stop.dist
                "
                >&#8226;</span
            >
            {{ stop?.dist | distance }}
        </div>
    </div>
</div>
